export default "__VITE_ASSET__C6VD6pGq__"